module.exports = __webpack_public_path__ + "static/media/Gallery-20.5fc85b7e.jpg";